import React, { useEffect } from 'react';
import Link from 'next/link';
import { useBookings } from '../hooks/useBookings';
import { usePaymentRoutes } from '@portal/env/hooks/payments/usePaymentRoutes';
import { useRouter } from 'next/router';
import { observer } from 'mobx-react';
import { useAuth } from '../hooks/useAuth';
import type { UnpaidBookingsData } from '@portal/types/nexudus/booking';

export const UnpaidBookingReminder = observer(() => {
  const { store } = useBookings();
  const unpaidBookings =
    store.unpaidBookings as unknown as UnpaidBookingsData | null;
  const { customer } = useAuth();
  const router = useRouter();
  const paymentRoutes = usePaymentRoutes();

  useEffect(() => {
    void store?.loadUnpaidBookings();

    const interval = setInterval(() => {
      void store?.loadUnpaidBookings();
    }, 60000);

    return () => clearInterval(interval);
  }, [store]);

  if (!store.hasLoadedUnpaidBookings) return null;

  const hasUnpaidBookings =
    (unpaidBookings?.BookingsToPay ?? 0) > 0 &&
    (unpaidBookings?.TimeToPay ?? 0) > 0;

  if (!hasUnpaidBookings || customer?.StripeDirectDebitPaymentsEnabled)
    return null;

  return (
    <div className="tw:flex tw:items-center tw:justify-center tw:bg-destructive-light tw:border tw:border-destructive/20 tw:px-6 tw:py-3">
      <div className="tw:text-sm tw:font-medium tw:text-destructive">
        {`Your bookings will be cancelled if not paid within ${Math.floor(unpaidBookings?.TimeToPay ?? 0)} minutes`}
      </div>

      {router.pathname.indexOf(paymentRoutes.checkout_payment) === -1 && (
        <Link
          href={paymentRoutes.checkout_payment}
          className="tw:ml-4 tw:rounded-full tw:bg-destructive tw:px-5 tw:py-2.5 tw:text-xs tw:font-semibold tw:text-white tw:shadow-sm hover:tw:bg-destructive"
        >
          Pay now
        </Link>
      )}
    </div>
  );
});
